import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "helped" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Thanks for reaching out", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " We've sent you an email confirmation of your inquiry. We will take a look and get back to you soon. ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}